import React from 'react';
import ReactDOM from 'react-dom/client';
import Clarity from '@microsoft/clarity';
import App from './App';
import './index.css';

if (!import.meta.env.DEV) {
  Clarity.init('vuv9ahwn8n');
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(<App />);
